const NIL = '00000000-0000-0000-0000-000000000000';

/**
 * Identity of a cart line.
 *
 * `addonsKey` defaults to '' so every existing two-argument call keys exactly
 * as it did before, and a product without add-ons is unaffected. See
 * `@/lib/cart/addons` for why the selection belongs in the identity at all.
 *
 * `productUnitId` joins it for the same reason: the same product bought by the
 * carton and by the piece are different purchases, and merging them would hide
 * the quantity-tier difference between the two lines.
 */
export function cartItemKey(
  productId: string,
  variantId?: string | null,
  addonsKey = '',
  productUnitId?: string | null,
): string {
  return `${productId}::${variantId ?? NIL}::${addonsKey}::${productUnitId ?? NIL}`;
}
